import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductTemplateForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'titel-skabeloner', dataApiName: 'ProductTemplate', text: 'Titelskabeloner', textSingular: "Titelskabelon",
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }, 
      fieldMetadata: [
        { name: 'internal', text: 'Intern', format: 'CheckBox', defaultValue: false },
        { fieldType: 'productGroup' },
        { fieldType: 'productComposition' },
        { fieldType: 'productForm' },
        { fieldType: 'productFormDetail' },

      ]
    });
  }
}
